/* ============================================================
   SELIERE UX — モーダル / クーポンフォーム / 動画自動再生 /
                ギャラリー余白 / 商品別アコーディオン
   ============================================================ */

var SEL_COUPON_CODE = 'WELCOME10';

/* ---------- クーポンモーダル（お名前＋メールをその場で受付） ---------- */
function selBuildCoupon() {
  var box = document.querySelector('#sel-modal-coupon .sel-modal__box');
  if (!box || box.dataset.selForm === '1') return;
  box.dataset.selForm = '1';

  var posted = location.search.indexOf('customer_posted=true') > -1;
  var html = '<button class="sel-modal__close" data-sel-close aria-label="閉じる">×</button>';

  if (posted) {
    html +=
      '<h3>ご登録ありがとうございます</h3>' +
      '<p>下記のクーポンコードを、お会計の「割引コード」欄にご入力ください。</p>' +
      '<div class="sel-code">' +
      '<span class="sel-code__val">' + SEL_COUPON_CODE + '</span>' +
      '<button type="button" class="sel-code__copy" data-sel-copy="' + SEL_COUPON_CODE + '">コードをコピー</button>' +
      '</div>' +
      '<p class="sel-modal__note">※他のクーポンとの併用はできません。<br>※税込¥5,000以上のご注文で全国送料無料です。</p>';
  } else {
    html +=
      '<h3>新規ご登録で10%OFF</h3>' +
      '<p>お名前とメールアドレスをご登録いただくと、<b>その場で</b>10%OFFクーポンコードを表示します。</p>' +
      '<form method="post" action="/contact#sel-coupon-form" id="sel-coupon-form" accept-charset="UTF-8" class="sel-cform">' +
      '<input type="hidden" name="form_type" value="customer">' +
      '<input type="hidden" name="utf8" value="&#10003;">' +
      '<input type="hidden" name="contact[tags]" value="newsletter,welcome10">' +
      '<div class="sel-cform__row">' +
      '<input type="text" name="contact[last_name]" required placeholder="お名前（例：山田）" autocomplete="family-name" aria-label="お名前">' +
      '</div>' +
      '<div class="sel-cform__row">' +
      '<input type="email" name="contact[email]" required placeholder="メールアドレス" autocomplete="email" aria-label="メールアドレス">' +
      '<button type="submit" class="sel-cform__submit">受け取る</button>' +
      '</div>' +
      '</form>' +
      '<p class="sel-modal__note">※新商品・セール情報のご案内をお送りします。配信はいつでも停止できます。<br>※税込¥5,000以上のご注文で全国送料無料です。</p>';
  }
  box.innerHTML = html;
}

/* ---------- 商品別アコーディオン ----------
   商品ページのテンプレートは全商品共通なので、アコーディオンの固定テキストを
   そのまま使うと全商品に同じ仕様が出てしまう。各商品の説明文から
   「商品仕様」「よくあるご質問」を抽出して差し替える。
   安全注記・免責表示・レビューブロックなどは説明文に残す（折りたたまない）。 */
var SEL_SHIP_HTML =
  '<ul>' +
  '<li><b>送料</b>：税込¥5,000以上のご注文で全国送料無料（¥5,000未満は全国一律¥800）</li>' +
  '<li><b>発送</b>：ご注文確定後5営業日以内　／　<b>お届け</b>：発送後10〜14営業日（海外提携倉庫より直送）</li>' +
  '<li><b>追跡</b>：発送後に追跡番号をメールでお知らせします</li>' +
  '<li><b>返品</b>：商品到着後30日以内・未開封・未使用に限り承ります（30日返品保証）</li>' +
  '<li><b>不良品・配送中の破損</b>：当店負担で交換または返金いたします</li>' +
  '<li><b>お支払い</b>：クレジットカード（Visa / Mastercard / JCB / AMEX）、Apple Pay、Google Pay、PayPal、Shop Pay</li>' +
  '</ul>' +
  '<p>30日間の返品保証つき。万一の初期不良も、交換・返金にて対応いたします。</p>';

/* 移動してよいのは本文系のタグだけ。DIVなどは安全注記やレビュー枠の可能性があるので
   そこでセクションを打ち切り、説明文側に残す。 */
var SEL_MOVABLE = { P: 1, UL: 1, OL: 1, TABLE: 1, DL: 1, BLOCKQUOTE: 1 };

function selAccordions() {
  var accs = [].slice.call(document.querySelectorAll('.product__accordion'));
  if (!accs.length) return;

  function findAcc(label) {
    for (var i = 0; i < accs.length; i++) {
      var s = accs[i].querySelector('summary');
      if (s && s.textContent.indexOf(label) > -1) return accs[i];
    }
    return null;
  }
  function body(acc) { return acc.querySelector('.accordion__content'); }

  /* 送料・お届け・返品は全商品共通の内容に統一 */
  var shipAcc = findAcc('送料');
  if (shipAcc && body(shipAcc)) body(shipAcc).innerHTML = SEL_SHIP_HTML;

  var found = { spec: [], faq: [] };
  var desc = document.querySelector('.product__description');
  if (desc) {
    var headEl = desc.querySelector('h2, h3');
    var box = headEl ? headEl.parentElement : desc;
    var cur = null;
    [].slice.call(box.children).forEach(function (n) {
      var tag = n.tagName;
      var txt = (n.textContent || '').replace(/[◆■★　\s]/g, '');
      var isHeading = tag === 'H2' || tag === 'H3' ||
        (tag === 'P' && txt.length <= 14 && /商品仕様|よくあるご質問/.test(txt));
      if (isHeading) {
        if (/商品仕様|^仕様$|サイズ・仕様|サイズ表/.test(txt)) cur = 'spec';
        else if (/よくあるご質問/.test(txt)) cur = 'faq';
        else if (/送料|お届けについて|お届け・返品|配送・/.test(txt)) cur = 'drop';
        else cur = null;   /* 「こんな方に」「安心してお試し」などは説明文に残す */
        if (cur) { n.parentNode.removeChild(n); }
        return;
      }
      if (!cur) return;
      if (!SEL_MOVABLE[tag]) { cur = null; return; }  /* DIV等はその場に残して区切る */
      if (cur === 'drop') { n.parentNode.removeChild(n); }
      else { found[cur].push(n); }
    });
  }

  var isNail = /ネイルケアライト/.test((document.querySelector('.product__title') || {}).textContent || '');

  [['spec', '商品仕様'], ['faq', 'よくあるご質問']].forEach(function (pair) {
    var acc = findAcc(pair[1]);
    if (!acc) return;
    var b = body(acc);
    if (found[pair[0]].length && b) {
      b.innerHTML = '';
      found[pair[0]].forEach(function (n) { b.appendChild(n); });
    } else if (!isNail) {
      acc.parentNode.removeChild(acc);   /* 共通テンプレートの残りを出さない */
    }
  });
}

/* ---------- モーダル ---------- */
document.addEventListener('DOMContentLoaded', function () {
  selBuildCoupon();
  try { selAccordions(); } catch (e) {}
  document.querySelectorAll('.sel-modal').forEach(function (m) {
    if (m.parentNode !== document.body) document.body.appendChild(m);
  });
  if (location.search.indexOf('customer_posted=true') > -1) {
    var m = document.getElementById('sel-modal-coupon');
    if (m) { m.hidden = false; document.body.style.overflow = 'hidden'; }
  }
});

function selOpenModal(m) {
  if (!m) return;
  if (m.parentNode !== document.body) document.body.appendChild(m);
  m.hidden = false;
  document.body.style.overflow = 'hidden';
}

document.addEventListener('click', function (e) {
  var open = e.target.closest('[data-sel-modal]');
  if (open) {
    selOpenModal(document.getElementById('sel-modal-' + open.dataset.selModal));
    e.preventDefault();
    return;
  }
  if (e.target.closest('[data-sel-close]')) {
    var box = e.target.closest('.sel-modal');
    if (box) { box.hidden = true; document.body.style.overflow = ''; }
    return;
  }
  var cp = e.target.closest('[data-sel-copy]');
  if (cp) {
    var code = cp.getAttribute('data-sel-copy');
    var done = function () {
      var old = cp.textContent;
      cp.textContent = 'コピーしました';
      setTimeout(function () { cp.textContent = old; }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, done);
    } else {
      var ta = document.createElement('textarea');
      ta.value = code; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (err) {}
      document.body.removeChild(ta); done();
    }
    e.preventDefault();
  }
});

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    document.querySelectorAll('.sel-modal:not([hidden])').forEach(function (m) { m.hidden = true; });
    document.body.style.overflow = '';
  }
});

/* ---------- ギャラリー動画の自動再生 ---------- */
(function () {
  var tries = 0;
  function prep(v) {
    v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('loop', '');
    v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    v.removeAttribute('controls'); v.controls = false;
  }
  function inView(el) {
    var r = el.getBoundingClientRect();
    if (r.width === 0 || r.height === 0) return false;
    return r.bottom > 0 && r.top < (window.innerHeight || 0) &&
           r.right > 0 && r.left < (window.innerWidth || 0);
  }
  function tick() {
    document.querySelectorAll('.sel-autovideo video, .product__media-item video').forEach(function (v) {
      prep(v);
      if (inView(v)) {
        if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else if (!v.paused) { v.pause(); }
    });
  }
  function boot() {
    tick();
    var iv = setInterval(function () { tick(); if (++tries > 120) clearInterval(iv); }, 500);
    document.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick);
    document.addEventListener('visibilitychange', tick);
    ['touchstart', 'click', 'keydown'].forEach(function (ev) {
      document.addEventListener(ev, tick, { passive: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ---------- ギャラリーの上下余白をなくす ---------- */
(function () {
  function fit() {
    var list = document.querySelector('.product__media-list');
    if (!list) return;
    var items = list.querySelectorAll('.product__media-item');
    if (!items.length) return;
    var lr = list.getBoundingClientRect();
    var best = null, bestOverlap = 0;
    items.forEach(function (it) {
      var r = it.getBoundingClientRect();
      var ov = Math.min(r.right, lr.right) - Math.max(r.left, lr.left);
      if (ov > bestOverlap) { bestOverlap = ov; best = it; }
    });
    if (!best) return;
    var box = best.querySelector('.product-media-container') || best.firstElementChild;
    if (!box) return;
    var h = box.getBoundingClientRect().height;
    if (h > 40) list.style.height = Math.round(h) + 'px';
  }
  function boot() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
    document.documentElement.classList.add('sel-fitgallery');
    fit();
    var list = document.querySelector('.product__media-list');
    if (list) list.addEventListener('scroll', function () {
      clearTimeout(list._selT); list._selT = setTimeout(fit, 60);
    }, { passive: true });
    window.addEventListener('resize', fit);
    window.addEventListener('load', fit);
    [300, 900, 1800].forEach(function (t) { setTimeout(fit, t); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
